import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { ChangeEvent, memo } from "react";
import { AddEditBinParams, accounts } from "./BinForm";
import TextInput from "../../../common/formElements/TextInput";
import CustomizedCheckbox from "../../../common/formElements/Checkbox";
import { includes } from "ramda";
import { FormikProps, useFormikContext } from "formik";
import { Bin, Data } from "../../../store/card/types";
import { useState, useEffect } from "react";
import pageStyles from "../../pageStyles";
import { Add, RemoveCircleOutline } from "@mui/icons-material/";
import { IconButton } from "@mui/material";
import { ApplicationState } from "../../../store";
import { useSelector } from "react-redux";
import SelectDropDown, {
  Option,
} from "../../../common/formElements/SelectDropDown";

interface AddEditBinDialogProps {
  cardTypes?: any;
  binEditAddDialogData: AddEditBinParams;
  setBinEditAddDialogData: (value: AddEditBinParams) => void;
  setFilteredBin?: (value: Bin[]) => void;
  filteredBin?: Bin[];
}

const AddEditBinDialog = (props: AddEditBinDialogProps) => {
  const classes = pageStyles();
  const formikProps = useFormikContext();
  const { isValid, values, setFieldValue } = formikProps as FormikProps<Data>;
  const {
    isOpen,
    isAddNew,
    binIndex,
    cardBinIndex,
    binData,
  } = props.binEditAddDialogData;
  const {
    setBinEditAddDialogData,
    setFilteredBin,
    filteredBin,
    cardTypes,
  } = props;

  const cards: Array<Option> = [];
  const [cardsDropdown, setCardsDropDown]: any = useState([]);

  const closeModal = () => {
    setBinEditAddDialogData({
      isOpen: false,
    });
  };

  const handleAccountChange = (
    account: string,
    cardBinIndex: number,
    binIndex: number
  ) => (event: ChangeEvent<HTMLInputElement>) => {
    const currentAccounts =
      values.attributes.CardBin?.[cardBinIndex].Bin[binIndex].Account || [];
    let newAccounts: string[];

    if (event.currentTarget.checked) {
      newAccounts = [...currentAccounts, account];
    } else {
      newAccounts = currentAccounts.filter(
        (x: string) => x.toLowerCase() !== account.toLowerCase()
      );
    }

    setFieldValue(
      `attributes.CardBin[${cardBinIndex}].Bin[${binIndex}].Account`,
      newAccounts
    );
  };
  const [inputFieldsKey, setInputFieldsKey] = useState([
    { Name: "", Value: "" },
  ]);
  const [inputFieldsFloor, setInputFieldsFloor] = useState([
    { Name: "", Value: 0 },
  ]);

  const handleAddBin = () => {
    if (
      cardBinIndex !== undefined &&
      binIndex !== undefined &&
      setFilteredBin
    ) {
      const newBin = {
        Account:
          values.attributes.CardBin?.[cardBinIndex].Bin[binIndex].Account || [],
        From:
          values.attributes.CardBin?.[cardBinIndex].Bin[binIndex].From || "",
        To: values.attributes.CardBin?.[cardBinIndex].Bin[binIndex].To || "",
        Keys: inputFieldsKey,
        FloorLimit: inputFieldsFloor,
        CardType:
          values.attributes.CardBin?.[cardBinIndex].Bin[binIndex].CardType ||
          "",
        Length: parseInt(
          values.attributes.CardBin?.[cardBinIndex].Bin[
            binIndex
          ].Length.toString() || "0",
          10
        ),
      };

      setFilteredBin([...(filteredBin || []), newBin]);
    }
    closeModal();
  };

  const prepareCardTypes = () => {
    if (Array.isArray(cardTypes)) {
      setCardsDropDown(cardTypes.map(i => i.type));
    }
  };

  useEffect(() => {
    if (
      cardBinIndex !== undefined &&
      binIndex !== undefined &&
      setFilteredBin
    ) {
        const temp: any = filteredBin[binIndex];
        setInputFieldsKey(temp?.Keys || []);
        setInputFieldsFloor(temp?.FloorLimit || []);
    }
    prepareCardTypes();
  }, [filteredBin]);

  const handleAdd = () => {
    setInputFieldsKey([...inputFieldsKey, { Name: "", Value: "" }]);
  };

  const handleAddFloor = () => {
    setInputFieldsFloor([...inputFieldsFloor, { Name: "", Value: 0 }]);
  };

  const handleChangeName = (event: any, index: any, type: string) => {
    if (type == "Key") {
      const values: any = [...inputFieldsKey];
      values[index].Name = event.target.value;
      setInputFieldsKey(values);
      setFieldValue(
        `attributes.CardBin[${cardBinIndex}].Bin[${binIndex}].Keys`,
        values
      );
    } else {
      const values: any = [...inputFieldsFloor];
      values[index].Name = event.target.value;
      setInputFieldsFloor(values);
      setFieldValue(
        `attributes.CardBin[${cardBinIndex}].Bin[${binIndex}].FloorLimit`,
        values
      );
    }
  };

  const handleChangeValue = (event: any, index: any, type: string) => {
    if (type == "Key") {
      const values: any = [...inputFieldsKey];
      values[index].Value = event.target.value;
      setInputFieldsKey(values);
      setFieldValue(
        `attributes.CardBin[${cardBinIndex}].Bin[${binIndex}].Keys`,
        values
      );
    } else {
      const values: any = [...inputFieldsFloor];
      values[index].Value = event.target.value;
      setInputFieldsFloor(values);
      setFieldValue(
        `attributes.CardBin[${cardBinIndex}].Bin[${binIndex}].FloorLimit`,
        values
      );
    }
  };

  const handleRemove = (index: number, type: string) => {
    if (type == "Key") {
      const values = [...inputFieldsKey];
      values.splice(index, 1);
      setInputFieldsKey(values);
    } else {
      const values = [...inputFieldsFloor];
      values.splice(index, 1);
      setInputFieldsFloor(values);
    }
  };

  const handleUpdateBin = () => {
    if (
      cardBinIndex !== undefined &&
      binIndex !== undefined &&
      setFilteredBin
    ) {
      const updatedBin = {
        Account:
          values.attributes.CardBin?.[cardBinIndex].Bin[binIndex].Account || [],
        From:
          values.attributes.CardBin?.[cardBinIndex].Bin[binIndex].From || "",
        To: values.attributes.CardBin?.[cardBinIndex].Bin[binIndex].To || "",
        Keys: inputFieldsKey,
        FloorLimit: inputFieldsFloor,
        CardType:
          values.attributes.CardBin?.[cardBinIndex].Bin[binIndex].CardType ||
          "",
        Length: parseInt(
          values.attributes.CardBin?.[cardBinIndex].Bin[
            binIndex
          ].Length?.toString() || "0",
          10
        ),
      };
      const updatedFilteredBin = [...(filteredBin || [])];
      updatedFilteredBin[binIndex] = updatedBin;
      setFieldValue(`attributes.CardBin[${cardBinIndex}].Bin[${binIndex}].Keys`, inputFieldsKey);
      setFilteredBin(updatedFilteredBin);
    }
    closeModal();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        closeModal();
      }}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        {isAddNew ? "Add New Bin" : "Edit Bin"}
        <Divider />
      </DialogTitle>
      <DialogContent style={{ paddingTop: 5 }}>
        <Grid container spacing={2}>
          <Grid item xs={4} md={3}>
            <TextInput
              fieldname={`attributes.CardBin[${cardBinIndex}].Bin[${binIndex}].From`}
              label="From"
            />
          </Grid>
          <Grid item xs={4} md={3}>
            <TextInput
              fieldname={`attributes.CardBin[${cardBinIndex}].Bin[${binIndex}].To`}
              label="To"
            />
          </Grid>
          <Grid item xs={4} md={3}>
            <TextInput
              fieldname={`attributes.CardBin[${cardBinIndex}].Bin[${binIndex}].Length`}
              label="Length"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectDropDown
              key={`card-type-${cardsDropdown.length}`}
              label="Card Type"
              fieldname={`attributes.CardBin[${cardBinIndex}].Bin[${binIndex}].CardType`}
              options={cardsDropdown}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            Accounts:
            <br />
            {accounts.map((account: string) => {
              return (
                <FormControlLabel
                  key={account}
                  control={
                    <CustomizedCheckbox
                      checked={includes(account, binData?.Account || [])}
                      onChange={handleAccountChange(
                        account,
                        cardBinIndex || 0,
                        binIndex || 0
                      )}
                      name="account"
                    />
                  }
                  label={account}
                />
              );
            })}
            <Divider style={{ margin: "5px 0" }} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Box mb={1}>Keys:</Box>
            <Box width="100%">
              {inputFieldsKey.map((item: any, index) => (
                <div key={'KEY'+index} className={classes.cardTypesDiv}>
                  <div
                    style={{
                      display: "flex",
                      minWidth: "350px",
                    }}
                  >
                    <Grid item xs={12} md={5} style={{ margin: "0 2px" }}>
                      <TextField
                        name="Name"
                        required
                        type="string"
                        label="Name"
                        onChange={(event: any) =>
                          handleChangeName(event, index, "Key")
                        }
                        value={item.Name}
                      />
                    </Grid>
                    <Grid item xs={12} md={5} style={{ margin: "0 2px" }}>
                      <TextField
                        name="Value"
                        required
                        type="string"
                        label="Value"
                        onChange={(event: any) =>
                          handleChangeValue(event, index, "Key")
                        }
                        value={item.Value}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <IconButton onClick={() => handleRemove(index, "Key")}>
                        <RemoveCircleOutline style={{ color: "red" }} />
                      </IconButton>
                    </Grid>
                  </div>
                </div>
              ))}
            </Box>
            <Box>
              <Button
                color="primary"
                variant="outlined"
                size="medium"
                endIcon={<Add />}
                onClick={handleAdd}
              >
                Add Key
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box mb={1}>Floor Limit:</Box>
            <Box width="100%">
              {inputFieldsFloor.map((item: any, index) => (
                <div key={index} className={classes.cardTypesDiv}>
                  <div
                    style={{
                      display: "flex",
                      minWidth: "350px",
                    }}
                  >
                    <Grid item xs={12} md={5} style={{ margin: "0 2px" }}>
                      <TextField
                        name="Name"
                        required
                        type="string"
                        label="Name"
                        onChange={(event: any) =>
                          handleChangeName(event, index, "Floor")
                        }
                        value={item.Name}
                      />
                    </Grid>
                    <Grid item xs={12} md={5} style={{ margin: "0 2px" }}>
                      <TextField
                        name="Value"
                        required
                        type="number"
                        label="Value"
                        onChange={(event: any) =>
                          handleChangeValue(event, index, "Floor")
                        }
                        value={item.Value}
                      />
                    </Grid>
                    <Box>
                      <IconButton onClick={() => handleRemove(index, "Floor")}>
                        <RemoveCircleOutline style={{ color: "red" }} />
                      </IconButton>
                    </Box>
                  </div>
                </div>
              ))}
            </Box>
            <Box>
              <Button
                color="primary"
                variant="outlined"
                size="medium"
                endIcon={<Add />}
                onClick={handleAddFloor}
              >
                Add Floor
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Box width="100%">
          <Divider />
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            marginTop={2}
          >
            <Button variant="outlined" onClick={closeModal}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={!isValid}
              onClick={isAddNew ? handleAddBin : handleUpdateBin}
            >
              {isAddNew ? "Add New" : "Update"}
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default memo(AddEditBinDialog);
